import React from "react";
import DrawerLayout from "../..";
import { BackArrowIcon } from "../../../../icons";
import TreeComp from "../../../Tree";
import "./style.scss";
interface PermissionDrawerProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  permissions: string[];
  setPermissions: (values: string[]) => void;
  onSave: (permissions: string[]) => void;
  onBack: () => void;
  loading: boolean;
  viewMode?: boolean;
  permissionsData?: Array<{
    module_id: number;
    module_name: string;
    permissions: Array<{ permission_id: number; permission_name: string }>;
  }>;
}

const PermissionDrawer: React.FC<PermissionDrawerProps> = ({
  open,
  setOpen,
  permissions,
  loading = false,
  setPermissions,
  onSave,
  onBack,
  permissionsData = [],
  viewMode = false,
}) => {
  const handleSave = () => {
    onSave(permissions);
    setOpen(false);
  };

  const buildTreeData = () => {
    return permissionsData.map((module) => ({
      value: `module-${module.module_id}`,
      label: module.module_name,
      children: module.permissions.map((perm) => ({
        value: `module-${module.module_id}-perm-${perm.permission_id}`,
        label: perm.permission_name,
      })),
    }));
  };

  return (
    <DrawerLayout
      open={open}
      setOpen={setOpen}
      title={viewMode ? "View permissions" : "Set permissions"}
      extra={
        <BackArrowIcon
          style={{ width: 12, height: 12, cursor: "pointer" }}
          onClick={onBack}
        />
      }
      loading={loading}
      onConfirm={!viewMode ? () => onSave(permissions) : undefined}
      confirmText={"Save"}
      cancelText="Cancel"
    >
      <div className="pt-2 tree">
        <TreeComp
          data={buildTreeData()}
          category="permissions"
          checkedExternal={permissions}
          setCheckedExternal={setPermissions}
          viewOnly={viewMode}
        />
      </div>
    </DrawerLayout>
  );
};

export default PermissionDrawer;
